import { ChatSummary } from 'types/chat';

type Group = { key: string; title: string; list: Array<ChatSummary> };

type Groups = {
  pinned: Group;
  today: Group;
  yesterday: Group;
  last7Days: Group;
  last30Days: Group;
  years: Record<number, Group>;
};

export const groupingChats = (list: ChatSummary[]): Group[] => {
  const groups: Groups = {
    pinned: { key: 'pinned', title: 'chat.groups.pinned', list: [] },
    today: { key: 'today', title: 'chat.groups.today', list: [] },
    yesterday: { key: 'yesterday', title: 'chat.groups.yesterday', list: [] },
    last7Days: { key: 'last7Days', title: 'chat.groups.last7Days', list: [] },
    last30Days: {
      key: 'last30Days',
      title: 'chat.groups.last30Days',
      list: [],
    },
    years: {},
  };

  if (!list) return [];

  const now = new Date();
  const todayStart = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
  ).getTime();

  const yesterdayStart = todayStart - 24 * 60 * 60 * 1000;
  const sevenDaysAgo = todayStart - 7 * 24 * 60 * 60 * 1000;
  const thirtyDaysAgo = todayStart - 30 * 24 * 60 * 60 * 1000;

  list.forEach((item) => {
    if (item.isPinned) {
      groups.pinned.list.push(item);
      return;
    }

    const itemDate = new Date(item.date);
    const itemTime = itemDate.getTime();
    const itemYear = itemDate.getFullYear();

    if (itemTime >= todayStart) {
      groups.today.list.push(item);
    } else if (itemTime >= yesterdayStart) {
      groups.yesterday.list.push(item);
    } else if (itemTime >= sevenDaysAgo) {
      groups.last7Days.list.push(item);
    } else if (itemTime >= thirtyDaysAgo) {
      groups.last30Days.list.push(item);
    } else {
      if (!groups.years[itemYear]) {
        groups.years[itemYear] = {
          key: `year-${itemYear}`,
          title: `${itemYear}`,
          list: [],
        };
      }
      groups.years[itemYear].list.push(item);
    }
  });

  return getGroupsArray(groups);
};

function getGroupsArray(groups: Groups): Group[] {
  const fixed: Group[] = [
    groups.pinned,
    groups.today,
    groups.yesterday,
    groups.last7Days,
    groups.last30Days,
  ];

  fixed[0].list.sort(sortByDate);
  fixed[1].list.sort(sortByDate);
  fixed[2].list.sort(sortByDate);

  const yearGroups: Group[] = Object.entries(groups.years)
    .sort(([yearA], [yearB]) => Number(yearB) - Number(yearA))
    .map(([_, group]) => group);

  return [...fixed, ...yearGroups];
}

function sortByDate(chatA: ChatSummary, chatB: ChatSummary) {
  return new Date(chatB.date).getTime() - new Date(chatA.date).getTime();
}
